
import { TimeIntervalEnum } from "../enums/timeIntervalEnum";

import * as appsettings from "../appsettings";
import * as dialog from "../dialog";
import * as main from "../main";
import * as moment from "moment";
import * as timeinterval from "../timeinterval";
import * as grid from "../grid";

let selectedPreComMsgLogID = 0;
let LABEL_ETooManyDays = "";
let dateTimeErrorMessageLabel = "";

function setVisibilityPeriodSelector(): void {

    const ddl = $("#TimeIntervalID").data("kendoDropDownList");

    if (ddl != null && ddl != undefined) {
        const timeinterval_value = parseInt(ddl.value());
        const show = (timeinterval_value == TimeIntervalEnum.AskedPeriod);
        main.setHideDiv("periodSelector", show);
    }
}

export function initialize(ETooManyDays: string, dateTimeErrorMessage: string): void {
    LABEL_ETooManyDays = ETooManyDays;
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    setVisibilityPeriodSelector();
    main.setHideDivBootstrap("PreComMsgResponsesGrid", false);
    main.setHideDiv("errorMessage", false);

    grid.loadGridOptions("PreComMsgResponseLogGrid");
    grid.loadGridOptions("PreComMsgResponsesGrid");

    searchButtonClicked();
}

export function searchButtonClicked(): void {
    $("#SearchButtonLoader").show();

    main.setHideDiv("DivLblTooMany", false);
    main.setHideDiv("DivGridMsg", false);
    main.setHideDiv("errorMessage", false);

    const selectedInterval = parseInt($("#TimeIntervalID").data("kendoDropDownList").value());
    const from = timeinterval.getBeginPeriodSelection(selectedInterval, null);
    const to = timeinterval.getEndPeriodSelection(selectedInterval, null);

    if (from != null && to != null) {
        const grid = $("#PreComMsgResponseLogGrid").data("kendoGrid");
        if (grid != null && grid != undefined) {
            grid.pager.dataSource.page(1);
            grid.dataSource.read();
        }
    }
    else {
        $("#SearchButtonLoader").hide();
        // make a message
        main.setHideDiv("errorMessage", true);

        const lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}


export function getAdditionalData(): { fromLocal: Date, toLocal: Date } {

    // defaults
    const beginDateTime = moment();
    let fromLocalMRL = new Date(beginDateTime.subtract(1, 'days').unix() * 1000);
    let toLocalMRL = new Date(beginDateTime.unix() * 1000);

    // timeinterval
    const ddl = $("#TimeIntervalID").data("kendoDropDownList");
    if (ddl != null && ddl != undefined) {
        const ddlval = parseInt(ddl.value());

        fromLocalMRL = timeinterval.getBeginPeriodSelection(ddlval, null);
        toLocalMRL = timeinterval.getEndPeriodSelection(ddlval, null);

        const tsDays = (toLocalMRL.getTime() - fromLocalMRL.getTime()) / (1000 * 3600 * 24);
        if (tsDays < 0 || tsDays >= 33) {

            // make a message
            main.setHideDiv("DivLblTooMany", true);

            const lblEmsg = $("#LblTooMany");
            if (lblEmsg != null && lblEmsg != undefined) {
                lblEmsg.text(LABEL_ETooManyDays);
            }

            fromLocalMRL = toLocalMRL = new Date(Date.now());
        }

        // always add future appointments when not AskedPeriod
        if (ddlval != TimeIntervalEnum.AskedPeriod) {
            toLocalMRL = new Date();
            toLocalMRL.setFullYear(toLocalMRL.getFullYear() + 1);
        }
    }

    return {
        fromLocal: fromLocalMRL,
        toLocal: toLocalMRL
    };
}

export function showIsVisible(dataItem: PreComMsgResponseGridVM): boolean {
    return dataItem.Sent != null;
}

export function deleteIsVisible(dataItem: PreComMsgResponseGridVM): boolean {
    return dataItem.Sent == null;
}

export function getAdditionalDataResp(): {  } {

    return {
        preComMsgLogID: selectedPreComMsgLogID
    };
}

export function onChangeTimeInterval(): void {
    setVisibilityPeriodSelector();
    main.setHideDivBootstrap("PreComMsgResponsesGrid", false);
}

export function showMessageResponse(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgResponseGridVM;
    selectedPreComMsgLogID = Number(dataItem.PreComMsgLogID);

    if (selectedPreComMsgLogID > 0) {
        main.setHideDivBootstrap("PreComMsgResponsesGrid", true);
        $("#PreComMsgResponsesGrid").data("kendoGrid").dataSource.read();
    }
}

export function deleteMessageResponse(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgResponseGridVM;
    selectedPreComMsgLogID = dataItem.PreComMsgLogID;

    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {

        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as PreComMsgResponseGridVM;

        // Post Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("PreComMsgResponseLog/Delete?preComMsgLogId=" + dataItem.PreComMsgLogID),
            success: function (responseData) {

                if (responseData != undefined && responseData != null) {
                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    }
                }

                // Refresh datasource grid
                $("#PreComMsgResponseLogGrid").data("kendoGrid").dataSource.read();
            }
        });
    }

    function callingCallback(): void {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function startChanged(): void {
}

export function endChanged(): void {
}

